import React from 'react';
import { Fingerprint, Loader2 } from 'lucide-react';
import { AppLogo } from '@/components/common/AppLogo';

interface BiometricLockScreenProps {
  isAuthenticating: boolean;
  onRetry: () => void;
}

export const BiometricLockScreen: React.FC<BiometricLockScreenProps> = ({ isAuthenticating, onRetry }) => (
  <div className="fixed inset-0 bg-gray-950 z-[200] flex flex-col items-center justify-center px-6">
    <AppLogo size="lg" variant="white" className="mb-10" />

    <div className="w-24 h-24 bg-white/10 rounded-full flex items-center justify-center mb-6">
      {isAuthenticating
        ? <Loader2 size={44} className="text-white animate-spin" />
        : <Fingerprint size={44} className="text-emerald-400" />
      }
    </div>

    <p className="text-white text-xl font-semibold mb-2 text-center">Application verrouillée</p>
    <p className="text-white/50 text-sm text-center mb-10">
      {isAuthenticating ? 'Vérification en cours…' : 'Utilisez votre biométrie ou code PIN pour déverrouiller'}
    </p>

    {!isAuthenticating && (
      <button
        onClick={onRetry}
        className="px-8 py-3.5 bg-emerald-500 text-white rounded-2xl font-semibold text-base active:bg-emerald-600"
      >
        Déverrouiller
      </button>
    )}
  </div>
);
